module.exports = __webpack_public_path__ + "media/promo/advent/images/cells/cell-20-f173de52dcc4b2eca8e160035c6c8255.png";